
import { useState } from "react";
import { UpgradeBanner } from "../shared/UpgradeBanner";
import { AuthForm } from "./AuthForm";

interface AuthContainerProps {
  showPricing: boolean;
  onShowPricing: (show: boolean) => void;
}

export const AuthContainer = ({ showPricing, onShowPricing }: AuthContainerProps) => {
  const [showAuth, setShowAuth] = useState(false);

  return (
    <>
      <UpgradeBanner 
        onPricingClick={() => onShowPricing(true)}
        onLoginClick={() => setShowAuth(true)}
      />
      <AuthForm 
        open={showAuth}
        onOpenChange={setShowAuth}
        onShowPricing={() => onShowPricing(true)}
      />
    </>
  );
};
